/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  arearange: {
    low: {
      name: 'Low',
      desc: 'The low or minimum value for each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'low',
      rawValue: [1],
      order: 1
    },
    values: null,
    high: {
      name: 'High',
      desc: 'The high or maximum value for each data point.',
      default: 'C',
      value: 'C',
      isData: true,
      mandatory: true,
      linkedTo: 'high',
      rawValue: [2],
      order: 2
    }
  },
  boxplot: {
    low: {
      name: 'Low',
      desc: 'The low value for each data point, signifying the lowest value in the sample set. The bottom whisker is drawn here.',
      default: 'B',
      value: 'B',
      isData: true,
      mandatory: true,
      linkedTo: 'low',
      rawValue: [1],
      order: 1
    },
    values: null,
    high: {
      name: 'High',
      desc: 'The rank for this points data label in case of collision. If two data labels are about to overlap, only the one with the highest labelrank will be drawn.',
      default: 'C',
      value: 'C',
      isData: true,
      mandatory: true,
      linkedTo: 'high',
      rawValue: [2],
      order: 2
    },
    median: {
      name: 'Median',
      desc: 'The median for each data point. This is drawn as a line through the middle area of the box.',
      default: 'D',
      value: 'D',
      mandatory: true,
      isData: true,
      linkedTo: 'median',
      rawValue: [3],
      order: 3
    },
    q1: {
      name: 'Q1',
      desc: 'The lower quartile for each data point. This is the bottom of the box.',
      default: 'E',
      value: 'E',
      mandatory: true,
      multipleValues: false,
      isData: true,
      previousValue: null,
      linkedTo: 'q1',
      rawValue: [4],
      order: 4
    },
    q3: {
      name: 'Q3',
      desc: 'The higher quartile for each data point. This is the top of the box.',
      default: 'F',
      value: 'F',
      mandatory: true,
      isData: true,
      linkedTo: 'q3',
      rawValue: [4],
      order: 5
    }
  },
  ohlc: {
    values: null,
    open: {
      name: 'Open',
      desc: 'The opening value of each data point.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'open',
      rawValue: [2],
      order: 1
    },
    high: {
      name: 'High',
      desc: 'The high or maximum value for each data point.',
      default: 'E',
      value: 'E',
      mandatory: true,
      isData: true,
      linkedTo: 'high',
      rawValue: [4],
      order: 2
    },
    low: {
      name: 'Low',
      desc: 'The low or minimum value for each data point.',
      default: 'D',
      value: 'D',
      multipleValues: false,
      previousValue: null,
      mandatory: true,
      isData: true,
      linkedTo: 'low',
      rawValue: [3],
      order: 3
    },
    close: {
      name: 'Close',
      desc: 'The closing value of each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      linkedTo: 'close',
      isData: true,
      rawValue: [1],
      order: 4
    }
  },
  candlestick: {
    values: null,
    open: {
      name: 'Open',
      desc: 'The opening value of each data point.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'open',
      rawValue: [2],
      order: 2
    },
    high: {
      name: 'High',
      desc: 'The high or maximum value for each data point.',
      default: 'E',
      value: 'E',
      mandatory: true,
      isData: true,
      linkedTo: 'high',
      rawValue: [4],
      order: 4
    },
    low: {
      name: 'Low',
      desc: 'The low or minimum value for each data point.',
      default: 'D',
      value: 'D',
      multipleValues: false,
      previousValue: null,
      mandatory: true,
      isData: true,
      linkedTo: 'low',
      rawValue: [3],
      order: 3
    },
    close: {
      name: 'Close',
      desc: 'The closing value of each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      linkedTo: 'close',
      isData: true,
      rawValue: [1],
      order: 1
    }
  },
  bubble: {
    values: null,
    y: {
      name: 'Y',
      desc: 'Y Position',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'y',
      rawValue: [1],
      order: 1
    },
    z: {
      name: 'Z',
      desc: 'Z Position.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'z',
      rawValue: [2],
      order: 2
    }
  },
  columnrange: {
    values: null,
    low: {
      name: 'Low',
      desc: 'The low or minimum value for each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'low',
      rawValue: [1],
      order: 1
    },
    high: {
      name: 'High',
      desc: 'The high or maximum value for each data point.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'high',
      rawValue: [2],
      order: 2
    }
  },
  errorbar: {
    values: null,
    low: {
      name: 'Low',
      desc: 'The lowest value of each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      linkedTo: 'low',
      isData: true,
      rawValue: [1],
      order: 1
    },
    high: {
      name: 'High',
      desc: 'The highest value of each data point.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'high',
      rawValue: [2],
      order: 2
    }
  },
  heatmap: {
    labels: null,
    values: null,
    xLabel: {
      name: 'X Label',
      desc: 'Choose a column for the X Values. Can be names or a date.',
      hidden: true,
      default: 'A',
      locked: true,
      value: 'A',
      addExtraColumn: 2,
      mandatory: true,
      isData: true,
      linkedTo: 'xLabel',
      rawValue: [0],
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 1
    },
    yLabel: {
      name: 'Y Label',
      desc: 'Choose a column for the Y Values. Can be names or a date.',
      hidden: true,
      default: 'B',
      addExtraColumn: 2,
      locked: true,
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'yLabel',
      rawValue: [1],
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 1
    },
    x: {
      name: 'X',
      desc: 'Choose a column for the category types. Can be names or a date.',
      default: 'A',
      value: 'A',
      locked: true,
      rawValue: [0],
      previousValue: null,
      linkedTo: 'x',
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    y: {
      name: 'Y',
      desc: 'Choose a column for the Y Values. Can be names or a date.',
      default: 'B',
      locked: true,
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'y',
      rawValue: [1],
      order: 1
    },
    value: {
      name: 'Value',
      desc: 'Enter column with the values you want to chart.',
      default: 'C',
      value: 'C',
      locked: true,
      mandatory: true,
      isData: true,
      linkedTo: 'value',
      rawValue: [2],
      order: 2
    }
  },
  item: {
    labels: null,
    values: null,
    name: {
      name: 'Name',
      desc: 'Choose a column for the category types.',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      linkedTo: ['name', 'x'],
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    y: {
      name: 'Value',
      desc: 'Choose a column with the values you want to chart.',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'y',
      rawValue: [1],
      order: 1
    }
  },
  sankey: {
    labels: null,
    values: null,
    from: {
      name: 'From',
      desc: 'Choose a column where the data is coming from.',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      linkedTo: 'from',
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    to: {
      name: 'To',
      desc: 'Choose a column where the data is going to.',
      default: 'B',
      value: 'B',
      rawValue: [1],
      previousValue: null,
      linkedTo: 'to',
      isData: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 1
    },
    weight: {
      name: 'Weight',
      desc: 'Choose a column for the weight of the connection.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'weight',
      rawValue: [2],
      order: 2
    }
  },
  packedbubble: {
    series: {
      name: 'Series',
      desc: 'Choose a column for the series',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      mandatory: true,
      order: 0,
      isData: true,
      locked: true
    },
    labels: null,
    values: null,
    extra: null,
    name: {
      name: 'Name',
      desc: 'Choose a column for the name',
      default: 'B',
      value: 'B',
      rawValue: [1],
      previousValue: null,
      linkedTo: 'name',
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0,
      locked: true
    },
    value: {
      name: 'Value',
      desc: 'Choose a column for the value',
      default: 'C',
      value: 'C',
      rawValue: [2],
      previousValue: null,
      linkedTo: 'value',
      isData: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 1,
      locked: true
    }
  },
  dependencywheel: {
    labels: null,
    values: null,
    from: {
      name: 'From',
      desc: 'Choose a column where the data is coming from.',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      linkedTo: 'from',
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    to: {
      name: 'To',
      desc: 'Choose a column where the data is going to.',
      default: 'B',
      value: 'B',
      rawValue: [1],
      previousValue: null,
      linkedTo: 'to',
      isData: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 1
    },
    weight: {
      name: 'Weight',
      desc: 'Choose a column for the weight of the connection.',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'weight',
      rawValue: [2],
      order: 2
    }
  },
  wordcloud: {
    labels: null,
    values: null,
    name: {
      name: 'Name',
      desc: 'Choose a column for the category types. Can be names or a date.',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      linkedTo: ['name'],
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    weight: {
      name: 'Weight',
      desc: 'The highest value of each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'weight',
      rawValue: [1],
      order: 1
    }
  },
  treemap: {
    labels: null,
    values: null,
    name: {
      name: 'Name',
      desc: 'Choose a column for the category types. Can be names or a date.',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      linkedTo: ['name'],
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    value: {
      name: 'Value',
      desc: 'The value',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'value',
      rawValue: [1],
      order: 1
    }
  },
  dumbbell: {
    low: {
      name: 'Low',
      desc: 'The low or minimum value for each data point.',
      default: 'B',
      value: 'B',
      mandatory: true,
      linkedTo: 'low',
      rawValue: [1],
      order: 1,
      isLabel: true
    },
    values: null,
    high: {
      name: 'High',
      desc: 'The high or maximum value for each data point.',
      default: 'C',
      value: 'C',
      isData: true,
      mandatory: true,
      linkedTo: 'high',
      rawValue: [2],
      order: 2
    }
  },
  vector: {
    labels: null,
    x: {
      name: 'X Coordinate',
      desc: 'The x coordinate for each data point.',
      default: 'A',
      value: 'A',
      mandatory: true,
      linkedTo: 'x',
      rawValue: [0],
      order: 0
    },
    values: null,
    y: {
      name: 'Y Coordinate',
      desc: 'The y coordinate for each data point.',
      default: 'B',
      value: 'B',
      isData: true,
      mandatory: true,
      linkedTo: 'y',
      rawValue: [1],
      order: 1
    },
    length: {
      name: 'Length',
      desc: 'The length of the point',
      default: 'C',
      value: 'C',
      isData: true,
      mandatory: true,
      linkedTo: 'length',
      rawValue: [2],
      order: 2
    },
    angle: {
      name: 'Angle',
      desc: 'The direction of the arrow',
      default: 'D',
      value: 'D',
      isData: true,
      mandatory: true,
      linkedTo: 'direction',
      rawValue: [3],
      order: 3
    }
  },
  timeline: {
    labels: null,
    values: null,
    y: {
      name: 'y',
      desc: 'Choose a column for the category types. Can be names or a date.',
      default: 'A',
      value: 'A',
      locked: true,
      rawValue: [0],
      previousValue: null,
      addExtraColumn: 1,
      linkedTo: 'y',
      hidden: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    name: {
      name: 'Header',
      desc: 'Choose a column for the headers. Can be names or a date.',
      default: 'A',
      value: 'A',
      locked: true,
      rawValue: [0],
      previousValue: null,
      linkedTo: ['name', 'x'],
      isLabel: true,
      mandatory: true,
      colors: {
        light: 'rgb(217, 244, 242)',
        dark: 'rgb(66, 200, 192)'
      },
      order: 0
    },
    label: {
      name: 'Label',
      desc: 'Some text to display in the label',
      default: 'B',
      locked: true,
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'label',
      rawValue: [1],
      order: 1
    },
    description: {
      name: 'Description',
      desc: 'Enter column with description for the timeline entry.',
      default: 'C',
      value: 'C',
      locked: true,
      mandatory: true,
      isData: true,
      linkedTo: 'description',
      rawValue: [2],
      order: 2
    }
  },

  // Maps
  tilemap: {
    values: null,
    labels: null,
    country_code: {
      name: 'Area code',
      desc: 'The country code',
      default: 'A',
      value: 'A',
      mandatory: true,
      isData: true,
      linkedTo: 'hc-a2',
      rawValue: [0]
    },
    name: {
      name: 'Area name',
      desc: 'Name',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: 'name',
      rawValue: [1]
    },
    x: {
      name: 'X Value',
      desc: 'X Value',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'x',
      rawValue: [2]
    },
    y: {
      name: 'Y Value',
      desc: 'Y Value',
      default: 'D',
      value: 'D',
      mandatory: true,
      isData: true,
      linkedTo: 'y',
      rawValue: [3]
    },
    value: {
      name: 'Value',
      desc: 'The value of the country',
      default: 'E',
      value: 'E',
      mandatory: true,
      isData: true,
      linkedTo: 'value',
      rawValue: [4]
    }
  },
  mapline: {
    values: null,
    hidden: true,
    labels: {
      name: 'Country code',
      desc: 'The country code',
      default: 'A',
      value: 'A',
      mandatory: true,
      isLabel: true,
      linkedTo: 'hc-key',
      rawValue: [0]
    },
    value: {
      name: 'Value',
      desc: 'The value of the country',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: ['value', 'x'],
      rawValue: [1]
    }
  },
  map: {
    values: null,
    labels: {
      name: 'Area',
      desc: 'The country code',
      default: 'A',
      value: 'A',
      mandatory: true,
      isLabel: true,
      linkedTo: 'hc-key',
      rawValue: [0]
    },

    value: {
      name: 'Value',
      desc: 'The value of the country',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: ['value', 'x'],
      rawValue: [1]
    }
  },
  mappoint: {
    values: null,
    labels: null,
    latitude: {
      name: 'Latitude',
      desc: 'Latitude',
      default: 'A',
      value: 'A',
      rawValue: [0],
      previousValue: null,
      isLabel: true,
      linkedTo: ['lat', 'x', 'y', 'id']
    },
    longitude: {
      name: 'Longitude',
      desc: 'Longitude',
      default: 'B',
      value: 'B',
      rawValue: [1],
      previousValue: null,
      isLabel: true,
      linkedTo: 'lon'
    },
    value: {
      name: 'Points',
      desc: 'The value of the country',
      default: 'C',
      value: 'C',
      mandatory: true,
      isData: true,
      linkedTo: 'name',
      rawValue: [2]
    },
    markerpoint: {
      name: 'Symbol (Beta)',
      desc: 'The symbol to use for the point',
      linkedTo: 'marker.symbol',
      default: '',
      value: '',
      rawValue: null,
      previousValue: null,
      mandatory: false,
      isExtra: true
    }
  },
  mapbubble: {
    values: null,
    labels: {
      name: 'Area',
      desc: 'The country name',
      default: 'A',
      value: 'A',
      isLabel: true,
      mandatory: false,
      linkedTo: 'hc-key',
      rawValue: [0]
    },
    latitude: {
      name: 'Latitude',
      desc: 'Latitude',
      default: '',
      value: '',
      rawValue: null,
      previousValue: null,
      isLabel: true,
      linkedTo: 'lat'
    },
    longitude: {
      name: 'Longitude',
      desc: 'Longitude',
      default: '',
      value: '',
      rawValue: null,
      previousValue: null,
      isLabel: true,
      linkedTo: 'lon'
    },
    value: {
      name: 'Bubbles',
      desc: 'The value of the country',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: ['z', 'x'],
      rawValue: [1]
    }
  },
  patternfill: {
    values: null,
    labels: {
      name: 'Area',
      desc: 'The country name',
      default: 'A',
      value: 'A',
      mandatory: true,
      isLabel: true,
      linkedTo: 'hc-key',
      rawValue: [0]
    },
    value: {
      name: 'Image',
      desc: 'The image path',
      default: 'B',
      value: 'B',
      mandatory: true,
      isData: true,
      linkedTo: ['value', 'color.pattern.image'],
      rawValue: [1]
    }
  }
};
